import { InputStatesEnum } from '../../FieldControlled/common.js';

const FieldValid = {};
const FieldRequired = {
    state: InputStatesEnum.alarm,
    stateMessage: 'Campo obbligatorio',
};
const FieldLoading = {
    state: InputStatesEnum.loading,
    stateMessage: undefined,
};

export { FieldLoading, FieldRequired, FieldValid };
